import { createBrowserRouter } from "react-router-dom";
import { routes } from "./routes";
import {
  GeneralLayout,
  AdminRootLayout,
  UserRootLayout,
  RootLayout,
  PUserRootLayout,

} from "../Layout";
import { ErrorAdminNavigationPage } from "../components";
import {
  AdminLogin,
  PsignUp,
  PuserLogin,
  ForgotPasscode,

} from "../pages/PreLogin";
import { checkAuthLoader } from "../common/common";
import Home from "../pages/Home";
import Admin from "../pages/Admin";
import AboutAlpaaGO from "../pages/AboutAlpaaGO";
import ContactUs from "../pages/ContactUs";
import PolicyPage from "../pages/Policies";
import { authSession } from "../assets/lib/login";
import { Dashboard } from "../pages/DashboardAdmin";
import { Ppod } from "../pages/PAdmin"
import { PuserInfo, PuserManagement, PuserProfile } from "../pages/PuserManagement";
import PUserTransaction from "../pages/PUserTransaction";
import { PauthSession } from "../assets/lib/plogin";
import Streaming from "../pages/Streaming";
import Help from "../pages/Help";
import Visitors from "../pages/Visitors";



import GuardLogin from "../pages/Guard/Login";
import GuardDashboard from "../pages/Guard/Dashboard";
import GuardLanding from "../pages/Guard/Default/Guard";

const createRoutes = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorAdminNavigationPage />,
    children: [
      { path: routes.DEFAULT, element: <Home /> },
      { path: routes.ABOUT_PAGE, element: <AboutAlpaaGO /> },
      { path: routes.ADMIN_PAGE, element: <Admin /> },
      { path: routes.CONTACT_PAGE, element: <ContactUs /> },
      { path: routes.PRIVACY_POLICY, element: <PolicyPage type="privacy" /> },
      { path: routes.TERMS_AND_CONDITIONS, element: <PolicyPage type="terms" /> },
      { path: routes.REFUND_POLICY, element: <PolicyPage type="refund" /> },
      { path: routes.RETURN_POLICY, element: <PolicyPage type="return" /> },
      { path: routes.DELIVERY_POLICY, element: <PolicyPage type="delivery" /> },
      { path: routes.GUARD, element: <GuardLanding /> },
      { path: routes.GUARD_LOGIN, element: <GuardLogin /> },
      { path: routes.GUARD_DASHBOARD, element: <GuardDashboard /> },
      {
        path: routes.PUSERS,
        element: <PUserRootLayout />,
        errorElement: <ErrorAdminNavigationPage />,
        children: [
          { path: routes.PSIGN_UP, element: <PsignUp /> },
          { path: routes.PUSER_LOGIN, element: <PuserLogin /> },
          { path: routes.FORGOT_PASSCODE, element: <ForgotPasscode /> },
          {
            path: routes.PUSER_TRANSACTION,
            element: <PUserTransaction />,
            loader: () => checkAuthLoader(PauthSession.puser),
          },
          {
            path: routes.PUSER_PROFILE,
            element: <PuserProfile />,
            loader: () => checkAuthLoader(PauthSession.puser),
          },
          {
            path: routes.LIVE_STREAMING,
            element: <Streaming />,
            loader: () => checkAuthLoader(PauthSession.puser),
          },
          {
            path: routes.HELP,
            element: <Help />,
            loader: () => checkAuthLoader(PauthSession.puser),
          },
          {
            path: routes.VISITORS,
            element: <Visitors />,
            loader: () => checkAuthLoader(PauthSession.puser),
          },
        ],
      },
      {
        path: routes.ADMIN,
        element: <AdminRootLayout />,
        errorElement: <ErrorAdminNavigationPage />,
        children: [
          { path: routes.ADMIN_LOGIN, element: <AdminLogin /> },
          { path: routes.ADMIN_PAGE, element: <Admin /> },
          {
            path: routes.DASHBOARD,
            element: <Dashboard />,
            loader: () => checkAuthLoader(authSession.admin),
          },
          {
            path: routes.PPOD_MANAGEMENT,
            element: <Ppod />,
            loader: () => checkAuthLoader(authSession.admin),
          },
          {
            path: routes.PUSER_MANAGEMENT,
            element: <GeneralLayout />,
            children: [
              { path: routes.DEFAULT, element: <PuserManagement /> },
              { path: routes.PUSER_INFO, element: <PuserInfo /> },
              { path: `${routes.PUSER_INFO}/:userDocId`, element: <PuserInfo /> },
            ],
            loader: () => checkAuthLoader(authSession.admin),
          },
        ],
      },
    ],
  },
]);

export default createRoutes;

